import Cookies from 'js-cookie';

// Cookies de sessao: so via HTTPS e nunca enviados em requisicao de outro site
// (o token vai no cabecalho Authorization, nao depende do cookie).
const SESSION_COOKIE_ATTRIBUTES: Cookies.CookieAttributes = {
  secure: true,
  sameSite: 'strict',
};

export const setCookie = (key: string, value: string, options?: any) => {
  Cookies.set(key, value, { ...SESSION_COOKIE_ATTRIBUTES, ...options });
};

export const getCookie = (key: string) => {
  return Cookies.get(key);
};

export const removeCookie = (key: string) => {
  Cookies.remove(key, SESSION_COOKIE_ATTRIBUTES);
};
